module.exports = __webpack_public_path__ + "img/credit-one-club-gal-5.e9be4031.jpg";